<template>
  <b122-login
    loginTitle="Bienvenue sur le backoffice PAROFIRST"
    loginSubtitle="Connectez vous pour accéder à la solution">
  </b122-login>
</template>

<script>
import B122Login from "../../components/b122/B122Login";
import {mapActions} from "vuex";

export default {
  name: "Login",
  components: {
    B122Login
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/auth/Login.vue